/** 경로 이동 관련 로직을 위한 상태 관리 스토어. */
import store from "../index.js";

export const modules = { store };

export const state = {
  prevNavigationPath: null, // string: 뒤로가기 시 이동해야 하는 이전 경로.
};

export const mutations = {
  setPrevNavigationPath(state, path) {
    state.prevNavigationPath = path;
  },
  resetPrevNavigationPath(state) {
    state.prevNavigationPath = null;
  },
};

export const actions = {};

export const getters = {
  getPrevNavigationPath(state) {
    return state.prevNavigationPath;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
